import { Entity } from "./Entity";
import { DumpsterSize } from "./Order";

export type DumpsterLocationType = "unknown" | "storage" | "order" | "on_truck";

export const dumpsterLocationTypeToText: Record<DumpsterLocationType, string> = {
  unknown: "Unknown",
  storage: "Storage",
  order: "Order",
  on_truck: "On Truck",
};

// Badge text for a dumpster's location. For on-truck dumpsters, append the truck
// label (e.g. "On Truck · Truck 5") when the vehicle can be resolved.
export const dumpsterLocationBadgeText = (
  locationType: DumpsterLocationType,
  truckLabel?: string
): string => {
  const base = dumpsterLocationTypeToText[locationType];
  if (locationType === "on_truck" && truckLabel) {
    return `${base} · ${truckLabel}`;
  }
  return base;
};

export type DumpsterFillStatus = "empty" | "half" | "full";

export const dumpsterFillStatusToText: Record<DumpsterFillStatus, string> = {
  empty: "Empty",
  half: "Half",
  full: "Full",
};

export interface Dumpster extends Entity {
  label: string;
  dumpsterSize: DumpsterSize;
  notes?: string;
  locationType: DumpsterLocationType;
  fillStatus: DumpsterFillStatus;
  currentOrderId?: string;
  currentStorageYardId?: string;
  // The vehicle the dumpster is currently on (location_type === "on_truck").
  // Populated from spec-040 vehicle tracking; resolve to a truck label via the vehicles list.
  currentVehicleId?: string;
  currentAddress: string;
  currentCity: string;
  currentZip: string;
  // Populated only when fetched with_coordinates=true, for order-located dumpsters
  // (the Dumpsters-tab map). Sourced from the dumpster's current order.
  customerName?: string;
  orderLatitude?: number;
  orderLongitude?: number;
}
